import { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import './LandingPage.css';
import NavBar from './components/NavBar';
import LandingModal from './components/LandingModal';
import PioneerPopup, { STORAGE_KEY as PIONEER_KEY } from './components/PioneerPopup';
import HeroSection from './sections/HeroSection';
import ArchitectureSection from './sections/ArchitectureSection';
import AllWidgetsSection from './sections/AllWidgetsSection';
import ScrollytellingSection from './sections/ScrollytellingSection';
import ComparisonSection from './sections/ComparisonSection';
import PricingSection from './sections/PricingSection';
import FAQSection from './sections/FAQSection';
import FinalCTASection from './sections/FinalCTASection';

const LandingPage = () => {
  const [modal, setModal] = useState({ open: false, mode: null, prefill: null });
  const [popupOpen, setPopupOpen] = useState(false);

  const openModal = (mode, prefill = null) => setModal({ open: true, mode, prefill });
  const closeModal = () => setModal(m => ({ ...m, open: false }));

  // Show pioneer popup after 8 seconds (once per session)
  useEffect(() => {
    try {
      if (sessionStorage.getItem(PIONEER_KEY)) return;
    } catch (_) { /* private browsing */ }

    const timer = setTimeout(() => setPopupOpen(true), 8000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Box sx={{ direction: 'rtl', overflowX: 'hidden', bgcolor: '#fcfbfa' }}>
      <NavBar onOpenModal={openModal} />
      <HeroSection />
      <ScrollytellingSection />
      <ArchitectureSection />
      <AllWidgetsSection />
      <ComparisonSection />
      <PricingSection onOpenModal={openModal} />
      <FAQSection onOpenModal={openModal} />
      <FinalCTASection onOpenModal={openModal} />

      <LandingModal
        open={modal.open}
        mode={modal.mode}
        prefill={modal.prefill}
        onClose={closeModal}
      />

      <PioneerPopup
        open={popupOpen}
        onClose={() => setPopupOpen(false)}
        onOpenModal={openModal}
      />
    </Box>
  );
};

export default LandingPage;
